// Generated, DO NOT EDIT MANUALLY.
import _styles from "#pplx/frontend/aether/components/internal/menu/MenuOverlay.module.css";

export const styles = _styles;
